"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinorityRefuge = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
const ColonyName_1 = require("../../colonies/ColonyName");
const BuildColony_1 = require("../../deferredActions/BuildColony");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class MinorityRefuge extends Card_1.Card {
    constructor() {
        super({
            cost: 5,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.MINORITY_REFUGE,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'C26',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(-2)).colonies(1);
                }),
                description: 'Decrease your M€ production 2 steps. Place a colony.',
            },
        });
    }
    canPlay(player) {
        if (player.hasAvailableColonyTileToBuildOn() === false) {
            return false;
        }
        const megaCreditsProduction = player.getProduction(Resources_1.Resources.MEGACREDITS);
        if (megaCreditsProduction === -4 && player.isCorporation(CardName_1.CardName.POSEIDON)) {
            return true;
        }
        else if (megaCreditsProduction <= -4) {
            const lunaIsAvailable = player.game.colonies.some((colony) => colony.name === ColonyName_1.ColonyName.LUNA &&
                colony.isColonyFull(player, player.game) === false &&
                colony.colonies.includes(player.id) === false);
            if (lunaIsAvailable === false) {
                return false;
            }
            this.warning = 'You will only be able to build the colony on Luna.';
        }
        return true;
    }
    play(player) {
        const openColonies = player.getProduction(Resources_1.Resources.MEGACREDITS) <= -4 ?
            player.game.colonies.filter((colony) => colony.name === ColonyName_1.ColonyName.LUNA) :
            undefined;
        player.game.defer(new BuildColony_1.BuildColony(player, false, 'Select colony for Minority Refuge', openColonies));
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            player.addProduction(Resources_1.Resources.MEGACREDITS, -2);
            return undefined;
        }));
        return undefined;
    }
}
exports.MinorityRefuge = MinorityRefuge;
//# sourceMappingURL=MinorityRefuge.js.map